export const productGalleryStyles = {
  root: 'flex flex-col gap-3 md:flex-row md:gap-4',
  main: 'aspect-square w-full overflow-hidden rounded-lg bg-brand-100 md:flex-1',
  mainImg: 'h-full w-full object-cover',
  thumbs:
    'flex gap-2 overflow-x-auto md:w-20 md:flex-col md:overflow-y-auto md:overflow-x-hidden',
  thumb:
    'h-16 w-16 shrink-0 overflow-hidden rounded-md border-2 border-transparent bg-brand-100 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 md:h-20 md:w-20',
  thumbActive: 'border-brand-400',
  thumbImg: 'h-full w-full object-cover',
} as const;
